const actionColumn = {
  alignHeader: 'center',
  alignColumns: 'center',
  key: 'actions',
  type: 'actions',
  width: 10,
};

export default actionColumn;
